import { render, staticRenderFns } from "./CostApportion.vue?vue&type=template&id=51f6f9f6&scoped=true&"
import script from "./CostApportion.vue?vue&type=script&lang=js&"
export * from "./CostApportion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f6f9f6",
  null
  
)

export default component.exports